import { EcmPartsService } from './../ecm-parts.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { EcmService } from '../../../ecm.service';
import { ToastrService } from 'ngx-toastr';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

interface EcmPartsAddprogramRelationData {
  partId: number;
  partName: string;
  partNumber: string;
}

@Component({
  selector: 'ecm-parts-add-program-relation',
  templateUrl: './ecm-parts-add-program-relation.component.html',
})
export class EcmPartsAddProgramRelationComponent implements OnInit {

  programs$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  part: EcmPartsAddprogramRelationData;
  relations: any[];

  addProgramRelationForm = new UntypedFormGroup({
    program: new UntypedFormControl(null, [Validators.required])
  });

  constructor(
    private readonly dialogRef: MatDialogRef<EcmPartsAddProgramRelationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly ecmService: EcmService,
    private readonly ecmPartsService: EcmPartsService,
    private readonly toastr: ToastrService
  ) { }

  ngOnInit() {
    this.part = this.data.part;
    this.relations = this.data.relations;

    this.ecmService.getAllPrograms()
      .pipe(map(programs => programs.filter(program => !this.relations.includes(program.id))))
      .subscribe(this.programs$.next.bind(this.programs$));
  }

  save() {
    if (!this.addProgramRelationForm.valid) {
      this.toastr.error('Missing required fields');
      return;
    }

    const program = this.addProgramRelationForm.get('program');

    this.ecmPartsService.createProgramPartRelation(program.value, this.part.partId)
      .subscribe(
        this.dialogRef.close.bind(this.dialogRef),
        () => this.toastr.error('Failed to create program part relation'),
        () => this.toastr.success('Program was successfully assigned to part!')
      );
  }

  close() {
    this.dialogRef.close();
  }
}
